import template from './_chat-message.pug'

// @vue/component
export default {
  template: template(),

  props: {
    chatMessage: {
      type: Object,
      required: true
    },
    // Se ha producido un cambio de usuario de un mensaje de chat a otro
    // Si es true, en este mensaje aparece el nombre de usuario, si es false no aparece
    userChange: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    municipality() {
      return this.$store.state.municipality
    },

    timeZone() {
      return this.municipality.time_zone
    },

    momentDate() {
      if (this.timeZone) return moment(this.chatMessage.created_at).tz(this.timeZone)
      return moment(this.chatMessage.created_at)
    },

    clientMessage() {
      return this.chatMessage.sender_type === 'Client'
    },

    chatClass() {
      let classStr = ''
      if (this.userChange) classStr = `${classStr} change-user-class`
      if (this.clientMessage) {
        classStr = `${classStr} client-class`
      } else {
        classStr = `${classStr} agence-class`
      }
      return classStr
    }
  }
}
